import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home.vue'
import success from '@/view/success.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'home',
        component: home
    }, {
        path: '/success',
        name: 'success',
        component: success
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js